import { jsx as _jsx } from "react/jsx-runtime";
import { HeartFillIcon, HeartIcon } from '@yonderland/andes-icons';
import { Badge, IconLink, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePageShow } from '../../hooks/usePageShow';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import { makeGetWishlistCounter } from '../../redux/wishList/selectors/WishListSelectors';
const WishListMenuItem = ({ link }) => {
    const dispatch = useDispatch();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const itemCount = useSelector(makeGetWishlistCounter());
    const hasItems = !!itemCount && itemCount > 0;
    usePageShow(() => {
        dispatch(wishListActions.getWishListProducts());
    });
    useEffect(() => {
        dispatch(wishListActions.getWishListProducts());
    }, []);
    return (_jsx("div", { "data-analytics-bannerid": "header-wishlist", children: _jsx(IconLink, { icon: {
                title: 'wishlist icon',
                source: isDesktop ? HeartFillIcon : HeartIcon,
                size: 'sm',
                color: 'brand',
                testId: 'wishlist',
            }, variant: "plain", size: "sm", href: link, children: hasItems && (_jsx(Badge, { size: "sm", color: "branded", testId: "wishlist_counter", children: itemCount })) }) }));
};
export default WishListMenuItem;
